// src/constants/countries.js
export const countries = [
    { code: 'EG', label: 'Egypt', phone: '20' },
];
